import {
  FlowTypes,
  MobileDeviceValue,
} from "@trailhead/smart-setup-core";
import {
  atom,
  RecoilState
} from "recoil";
import { localStorageEffect } from "./recoilLocalStorageEffect";

export interface DeviceContext {
  newDeviceObName: MobileDeviceValue | null,
  oldDeviceObName: MobileDeviceValue | null,
  oldDeviceFunctional: boolean | null,
  oldDeviceAccess: boolean | null,
  newDeviceActivated: boolean | null,
  deviceFlowType: FlowTypes | null,
  newDeviceIsiPhone14: boolean | null,
  updateNewDeviceObName: (value: MobileDeviceValue) => void,
  updateOldDeviceObName: (value: MobileDeviceValue) => void,
  updateOldDeviceFunctional: (value: boolean) => void,
  updateOldDeviceAccess: (value: boolean) => void,
  updateNewDeviceActivated: (value: boolean) => void,
  updateDeviceFlowType: (value: FlowTypes) => void,
  updateNewDeviceIsiPhone14: (value: boolean) => void,
};

export const newDeviceObNameState: RecoilState<MobileDeviceValue | null> = atom({
  key: "newDeviceObName",
  default: null as MobileDeviceValue | null,
  effects: [
    localStorageEffect("newDeviceObName"),
  ]
});

export const oldDeviceObNameState: RecoilState<MobileDeviceValue | null> = atom({
  key: "oldDeviceObName",
  default: null as MobileDeviceValue | null,
  effects: [
    localStorageEffect("oldDeviceObName"),
  ]
});

export const oldDeviceFunctionalState: RecoilState<boolean | null> = atom({
  key: "oldDeviceFunctional",
  default: null as boolean | null,
  effects: [
    localStorageEffect("oldDeviceFunctional"),
  ]
});

export const oldDeviceAccessState: RecoilState<boolean | null> = atom({
  key: "oldDeviceAccess",
  default: null as boolean | null,
  effects: [
    localStorageEffect("oldDeviceAccess"),
  ]
});

export const newDeviceActivatedState: RecoilState<boolean | null> = atom({
  key: "newDeviceActivated",
  default: null as boolean | null,
  effects: [
    localStorageEffect("newDeviceActivated"),
  ]
});

export const deviceFlowTypeState: RecoilState<FlowTypes | null> = atom({
  key: "deviceFlowType",
  default: null as FlowTypes | null,
  effects: [
    localStorageEffect("deviceFlowType"),
  ]
});

export const newDeviceIsiPhone14State: RecoilState<boolean | null> = atom({
  key: "newDeviceIsiPhone14",
  default: null as boolean | null,
  effects: [
    localStorageEffect("newDeviceIsiPhone14")
  ]
});

export const componentRefListState: RecoilState<Record<string, HTMLElement | null>> = atom({
  key: "componentRefList",
  default: {} as Record<string, HTMLElement | null>
});
